module.exports = __webpack_public_path__ + "click.mp3?4dbb11c0945ae8182473df0cf919772b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/click.mp3
// module id = 29
// module chunks = 0